




























import { defineComponent, ref, PropType, useContext } from '@nuxtjs/composition-api';
import { useWishlistShare } from '~/composables/useShareWishList/useWishlistShare';
import { useUiNotification } from '~/composables';

interface WishlistItemComment {
  item_id: number
  comment: string
}

interface WishlistProduct {
  id: number | string;
  description?: string;
}

export default defineComponent({
    name: 'shareWishlistFormPopup',
    components: {

    },
    props: {
        sharing_code : {
            type: String,
            default: ''
        },
        showPopup: {
            type: Boolean,
            default: false
        },
        item_comments: {
            type: Array as PropType<WishlistItemComment[]>,
            default: () => []
        },
        products: {
            type: Array as PropType<WishlistProduct[]>,
            default: () => []
        }
    },
    setup(props, { emit }) {
        const emails = ref('')
        const message = ref('')
        const sharingCode = ref(props.sharing_code);
        const { shareWishlist, loading, error, successMessage } = useWishlistShare()
        const getItemComments = () => props.products .filter(p => !!p.description?.trim()) .map(p => ({ item_id: Number(p.id), comment: p.description.trim() }));
        const closePopup = () => { emit('closePopup'); };
        const { send: sendNotification } = useUiNotification();
        const { app: { i18n } } = useContext();
        const submitForm = async () => {
            if (!emails.value.trim()) {
                alert('Please enter at least one email.')
                return
            }
            const emailList = emails.value.split(',').map(email => email.trim())
            await shareWishlist({
                recipient_emails: emailList,
                message: message.value,
                sharing_code: sharingCode.value,
                item_comments: getItemComments()
            })
            if (successMessage.value) {
                addSuccessMessageNotification(successMessage.value)
                closePopup()
            } else if (error.value) {
                addfailMessageNotification(error.value)
            }
        }

        const addSuccessMessageNotification = (successMessage) => {
            sendNotification({
                id: Symbol('mail_send'),
                type: 'success',
                icon: 'check',
                persist: false,
                message: i18n.t(successMessage) as string,
            });
        }

        const addfailMessageNotification = (faildMessage) => {
            sendNotification({
                id: Symbol('mail_not_send'),
                type: 'danger',
                icon: 'cross',
                persist: false,
                message: i18n.t(faildMessage) as string,
                title: 'Error',
            });
        }
        return {
            closePopup,
            submitForm,
            emails,
            message,
            loading
        }
    },
});
